<!-- Child: FAQComponent.vue -->
<template>
  <div class="faq-container">
    <div class="modal-title">
      <h2> FAQ </h2>
    </div>

    <!-- We use the current rotation data for the HelpCard -->
    <HelpCardComponent
        :cardTitle="currentRotation.q"
        :cardMessage="currentRotation.a"
    />

    <div class="faq-rotation-indicator" aria-label="FAQ rotation progress">
      <span>Next question in {{ secondsUntilNext }}s</span>
      <span class="faq-rotation-indicator__track" aria-hidden="true">
        <span
          class="faq-rotation-indicator__progress"
          :style="{ width: `${rotationProgress}%` }"
        />
      </span>
    </div>
  </div>
</template>

<script>
import HelpCardComponent from '@/components/contact/HelpCardComponent.vue';

export default {
  components: { HelpCardComponent },
  props: {
    faqData: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      activeIndex: 0,
      timer: null,
      secondsUntilNext: 20,
    };
  },
  computed: {
    // This dynamically returns the Q&A based on the activeIndex
    currentRotation() {
      if (this.faqData && this.faqData.length > 0) {
        return this.faqData[this.activeIndex];
      }
      return { q: "Loading...", a: "..." };
    },
    rotationProgress() {
      return ((20 - this.secondsUntilNext) / 20) * 100;
    },
  },
  methods: {
    startRotation() {
      this.timer = setInterval(() => {
        if (this.secondsUntilNext > 1) {
          this.secondsUntilNext -= 1;
          return;
        }

        this.activeIndex = (this.activeIndex + 1) % this.faqData.length;
        this.secondsUntilNext = 20;
      }, 1000);
    }
  },
  mounted() {
    this.startRotation();
  },
  beforeUnmount() {
    // IMPORTANT: Stop the timer if the user leaves the page to prevent memory leaks
    clearInterval(this.timer);
  }
}
</script>
